import React, { useCallback } from 'react';

import { learnLinks } from '../../defaultLinks';
import BaseMenu from '../BaseMenu';
import BaseMenuSection from '../BaseMenuSection';

interface LearnMenuProps {
  onClickLink?: (clickProperties: any, closeMobileMenu: boolean) => void;
}

const LearnMenu = ({ onClickLink }: LearnMenuProps) => {
  const onClickHandler = useCallback(
    (properties: any, closeMobileMenu: boolean) => {
      if (onClickLink) {
        onClickLink(
          {
            name: 'Clicked Main Nav',
            properties: {
              ...properties,
              tabName: 'Learn',
              clickEndLocation: 'Learn',
            },
          },
          closeMobileMenu,
        );
      }
    },
    [onClickLink],
  );

  return (
    <BaseMenu testId="learn-menu">
      <BaseMenuSection links={learnLinks} onClick={onClickHandler} />
    </BaseMenu>
  );
};

export default LearnMenu;
